import mobile from '../assets/mobile.webp'
import laptop from '../assets/laptop.webp'
import airpods from '../assets/airpods.jpg'
import Case from '../assets/Case.jpg'
import tablet from '../assets/tablet.jpg'
import watch from '../assets/watch.jpg'

export const PRODUCTS =[
    {
        id : 1,
        productName : "Mobile",
        price : 1000,
        productImage : mobile
    },
    {
        id : 2,
        productName : "Laptop",
        price : 1500,
        productImage : laptop
    },
    {
        id : 3,
        productName : "Airpods",
        price : 1700,
        productImage : airpods
    }
    ,
    {
        id : 4,
        productName : "Case",
        price : 1700,
        productImage : Case
    } ,
    {
        id : 5,
        productName : "Tablet",
        price : 500,
        productImage : tablet
    },
    {
        id : 6,
        productName : "Watch",
        price : 800,
        productImage : watch
    }
]